module.exports = __webpack_public_path__ + "static/logo-34b4b4041e66e266416dd550df4e4948.png";